import { DocumentDetails } from '@mercator-gcp/types/backend/Document';
import { useQuery } from 'react-query';
import { useApi } from 'hooks/useApi';
import DocumentsAPI from 'services/API/DocumentsAPI';
import ProjectsAPI from 'services/API/ProjectsAPI';
import { LandTitle } from 'types/LandTitle';
import type { Project } from 'types';

export const useProjectLandTitleValue = (projectSlug: Project['slug']) => {
  const api = useApi();

  return useQuery(
    ['get-project-land-title-value', projectSlug],
    async (): Promise<LandTitle[] | undefined> => {
      const response = await api.get<LandTitle[] | null>(
        ProjectsAPI.getProjectLandTitleAssessmentValue(projectSlug),
      );

      // Sort response by event_created_at in descending order
      if (response) {
        return response.sort(
          (a, b) =>
            new Date(b.event_created_at).getTime() -
            new Date(a.event_created_at).getTime(),
        );
      }

      return response || undefined;
    },
    { refetchOnWindowFocus: false },
  );
};

export const useDocumentLandTitleValue = (documentId: DocumentDetails['id']) => {
  return useQuery(
    ['get-document-land-title-value', documentId],
    async (): Promise<LandTitle[] | undefined> => {
      const response =
        await DocumentsAPI.getProjectLandTitleAssessmentValueByDocumentId(documentId);

      // Sort response by event_created_at in descending order
      if (response.data) {
        return response.data.sort(
          (a, b) =>
            new Date(b.event_created_at).getTime() -
            new Date(a.event_created_at).getTime(),
        );
      }

      return response.data || undefined;
    },
    { refetchOnWindowFocus: false },
  );
};
